/**
 * ProjectStore serves as a cache for the list of projects and project details returned by the dataService
 * and is responsible to transform this data into the format expected by the view.
 * @param dataService must have a function fetchProjects and fetchProjectDetails(id)
 */
export const ProjectStore = function(dataService) {
  var localProjects;
  const localDetails = new Map();

  function toViewModel(project) {
    return project;
  }

  /**
   * Returns a promise that resolves to an array of project objects:
   * [{
   *  id,
      title,
      titleImg,
      shortDescription,
   * }]
   */
  function getProjects() {
    if (localProjects) {
      return Promise.resolve(localProjects);
    }
    return dataService.fetchProjects().then(result => {
      localProjects = result.map(toViewModel);
      return localProjects;
    });
  }

  /**
   * Returns a promise that resovles to a project detail object:
   * {
   *  id,
      markdown,
      coverImg,
   * }
   * @param id the project id
   */
  function getProjectDetails(id) {
    if (localDetails.has(id)) {
      return Promise.resolve(localDetails.get(id));
    }
    return dataService.fetchProjectDetails(id).then(result => {
      localDetails.set(id, result);
      return result;
    });
  }

  return Object.freeze({
    getProjects,
    getProjectDetails
  });
};
